<div class="mt-6">
  <div class="user-info-form-scope">
    <app-dynamic-form [formGroup]="userInfoForm" [formConfigs]="formConfigs" [onSubmit]="onSubmit" [spinLoader]="spinLoader" />
  </div>
</div>